<template>
  <div class="theme-switcher relative">
    <button @click="toggleDropdown" class="btn btn-circle btn-ghost">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="4"></circle>
        <path d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"></path>
      </svg>
    </button>
    <div v-if="dropdownOpen" class="absolute right-0 top-full p-2 shadow-lg bg-base-100 rounded-box w-40 mt-2 z-100 max-h-96 overflow-y-auto border border-base-300 flex flex-col gap-0.5" @click.stop>
      <div class="text-xs opacity-50 px-2 py-1">✨ Custom</div>
      <button @click="setTheme('vapor')" class="btn btn-ghost btn-sm justify-start font-medium">Vapor</button>
      <div class="text-xs opacity-50 px-2 py-1 mt-1">Light</div>
      <button @click="setTheme('light')" class="btn btn-ghost btn-sm justify-start">Light</button>
      <button @click="setTheme('cupcake')" class="btn btn-ghost btn-sm justify-start">Cupcake</button>
      <button @click="setTheme('bumblebee')" class="btn btn-ghost btn-sm justify-start">Bumblebee</button>
      <button @click="setTheme('emerald')" class="btn btn-ghost btn-sm justify-start">Emerald</button>
      <button @click="setTheme('corporate')" class="btn btn-ghost btn-sm justify-start">Corporate</button>
      <button @click="setTheme('lofi')" class="btn btn-ghost btn-sm justify-start">Lo-Fi</button>
      <button @click="setTheme('pastel')" class="btn btn-ghost btn-sm justify-start">Pastel</button>
      <button @click="setTheme('winter')" class="btn btn-ghost btn-sm justify-start">Winter</button>
      <div class="text-xs opacity-50 px-2 py-1 mt-1">Dark</div>
      <button @click="setTheme('dark')" class="btn btn-ghost btn-sm justify-start">Dark</button>
      <button @click="setTheme('synthwave')" class="btn btn-ghost btn-sm justify-start">Synthwave</button>
      <button @click="setTheme('cyberpunk')" class="btn btn-ghost btn-sm justify-start">Cyberpunk</button>
      <button @click="setTheme('dracula')" class="btn btn-ghost btn-sm justify-start">Dracula</button>
      <button @click="setTheme('night')" class="btn btn-ghost btn-sm justify-start">Night</button>
      <button @click="setTheme('coffee')" class="btn btn-ghost btn-sm justify-start">Coffee</button>
      <button @click="setTheme('forest')" class="btn btn-ghost btn-sm justify-start">Forest</button>
      <button @click="setTheme('luxury')" class="btn btn-ghost btn-sm justify-start">Luxury</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, watch } from 'vue'

const dropdownOpen = ref(false)

const setTheme = (themeName: string): void => {
  document.documentElement.setAttribute('data-theme', themeName)
  localStorage.setItem('theme', themeName)
  dropdownOpen.value = false
}

const toggleDropdown = (e: Event): void => {
  e.stopPropagation()
  dropdownOpen.value = !dropdownOpen.value
}

const handleClickOutside = (e: MouseEvent): void => {
  const target = e.target as HTMLElement
  if (!target.closest('.theme-switcher')) {
    dropdownOpen.value = false
  }
}

// Add/remove click listener based on dropdown state
watch(dropdownOpen, (isOpen) => {
  if (isOpen) {
    document.addEventListener('click', handleClickOutside)
  } else {
    document.removeEventListener('click', handleClickOutside)
  }
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

// Load saved theme on component mount
onMounted(() => {
  const savedTheme = localStorage.getItem('theme') || 'bumblebee'
  document.documentElement.setAttribute('data-theme', savedTheme)
})
</script>
